import { Pipe, PipeTransform } from '@angular/core';
import { HowFindJobOpportunityEnum } from '../../../../models/job-opportunity.models';
import { getApplicationSourceLabelKey } from '../../../../root/application-source/application-source.util';

@Pipe({
  name: 'howFindJobOpportunityEnum',
  standalone: false,
})
export class HowFindJobOpportunityEnumPipe implements PipeTransform {
  transform(
    howFindJobOpportunity?: HowFindJobOpportunityEnum | null,
    otherChannels?: string | null,
  ): string {
    if (howFindJobOpportunity == null) return '-';
    if (howFindJobOpportunity === HowFindJobOpportunityEnum.others && otherChannels) {
      return otherChannels;
    }

    return getApplicationSourceLabelKey(howFindJobOpportunity) ?? '-';
  }
}
